import { DEFAULT_LOCALE, UserLocale } from '@/shared/config';

const LOCALE_ALIASES: Record<string, UserLocale> = {
  en: DEFAULT_LOCALE,
};

export const normalizeLocale = (
  locale: UserLocale = DEFAULT_LOCALE,
): UserLocale => LOCALE_ALIASES[locale] ?? locale;

export const getMessages = async (
  locale: UserLocale = DEFAULT_LOCALE,
): Promise<Record<string, string>> => {
  const normalizedLocale = normalizeLocale(locale);

  try {
    return await import(`../lang/${normalizedLocale}.json`).then(
      (m) => m.default,
    );
  } catch (error) {
    if (normalizedLocale === DEFAULT_LOCALE) {
      throw error;
    }

    return import(`../lang/${DEFAULT_LOCALE}.json`).then((m) => m.default);
  }
};
